/**
 * ExecutiveScorecardBoard — Iter-158 · Phase 0a consolidated source.
 * Reads /api/exec-finance/tiles as the single source of truth so
 * contracted_revenue / MRR / ARR / backlog / DSO / renewal_rate_pct
 * all reconcile from one contracts+invoices read.
 */
import { useEffect, useState } from 'react';
import { Card } from '../ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ExecutiveScorecardBoard() {
  const [snap, setSnap] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/api/exec-finance/tiles`, { credentials: 'include' });
        if (r.ok) setSnap(await r.json());
        else setErr(`Executive tiles ${r.status}: ${await r.text()}`);
      } catch (e) { setErr(String(e.message)); }
    })();
  }, []);
  if (err) return <p className="text-xs text-red-400" data-testid="exec-scorecard-error">{err}</p>;
  if (!snap) return <p className="text-zinc-500 text-sm" data-testid="exec-scorecard-loading">Loading executive dashboard…</p>;
  const kpis = [
    ['Contracted Revenue', snap.contracted_revenue != null ? `$${Number(snap.contracted_revenue).toLocaleString()}` : '—'],
    ['MRR', snap.mrr != null ? `$${Number(snap.mrr).toLocaleString()}` : '—'],
    ['ARR', snap.arr != null ? `$${Number(snap.arr).toLocaleString()}` : '—'],
    ['Backlog', snap.backlog != null ? `$${Number(snap.backlog).toLocaleString()}` : '—'],
    ['DSO (days)', snap.dso_days != null ? String(snap.dso_days) : '—'],
    ['Renewal Rate', snap.renewal_rate_pct != null ? `${snap.renewal_rate_pct}%` : '—'],
  ];
  return (
    <div className="space-y-4" data-testid="exec-scorecard-board">
      <p className="text-[10px] uppercase tracking-widest text-zinc-500">
        Single source of truth · /api/exec-finance/tiles · {snap.active_contracts} active contracts.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {kpis.map(([label, value]) => (
          <Card key={label} className="p-4 bg-[#141414] border-zinc-800" data-testid={`exec-kpi-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
            <p className="text-[10px] uppercase tracking-widest text-zinc-400">{label}</p>
            <p className="text-2xl font-bold text-white mt-1" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>{value}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
